import { LOGOUT } from 'portal-modules/auth/redux/modules/user'

// action types
export const UPDATE_META = 'rp/meta/UPDATE_META'

export const initialState = {
  alerts: { days: 30 },
  messages: { page: 0, page_size: 50, total: 0 },
}

// reducer
export default (state = initialState, { payload, type }) => {
  switch (type) {
    case UPDATE_META:
      return {
        ...state,
        [payload.key]: { ...(state[payload.key] || {}), ...payload.updates },
      }
    case LOGOUT:
      return initialState
    default:
      return state
  }
}

// action creators
// payload = { key: string, updates: object }
export const updateMeta = payload => ({
  type: UPDATE_META,
  payload,
})
